<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">Acknowledgments</h2>
<p class="noindent">Friends and family, you supported me during my toughest challenges and for that I am truly grateful. Like so many others, I needed the encouragement to keep going, so thank you for not allowing me to settle. Thank you for continually putting me in situations in which I could grow and see just how amazing I truly am. Lastly, thank you for being the inspiration I needed to find my voice and become the person I knew I could be.</p>
<p class="indent">Mentors, coaches, and advisors, words cannot express what it has meant to receive your guidance and support over the years. In many ways, you took a chance on me by believing in my capabilities long before I did. You led me to create my own path and held my hand every step of the way. Thank you for knowing just what I needed to keep pushing forward. I will always acknowledge and be grateful for your support.</p>
<p class="indent">Lastly, special thanks to Danielle C. Miller, Patricia A. Sullivan, and Dr. Lashun Aron for your feedback and contributions.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?21e974c7